import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Servizi from "@/pages/Servizi";
import PrezziSoluzioni from "@/pages/PrezziSoluzioni";
import ChiSiamo from "@/pages/ChiSiamo";
import Portfolio from "@/pages/Portfolio";
import Contatti from "@/pages/Contatti";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/servizi" element={<Servizi />} />
              <Route path="/prezzi" element={<PrezziSoluzioni />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/contatti" element={<Contatti />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
